export default class Campaign {
    constructor(Rest) {
        this.rest = Rest.rest;
    }

    find(id, messageType) {
        return this.rest.one('campaign', id).get({ message_type: messageType });
    };

    findAll() {
        return this.rest.one('campaign').one('findAll').get();
    };

    update(id, campaign) {
        return this.rest.one('campaign/' + id).put(campaign);
    };

    findAllByStatus(status, page, view) {
        return this.rest.one('campaign').get({ status: status, page: page || 1, view: view });
    };

    searchByStatus(status, query, view, page) {
        page = page || 1;
        view = view || 'cards';

        return this.rest.one('campaign').one('search').get({ status: status, query: query, view: view, page: page });
    };

    export(page, query, view) {
        return this.rest.all('campaign/export').post({ page: page, query: query, view: view });
    };
    
    exportProgress() {
        return this.rest.one('campaign').one('exportProgress').get();
    };

    getSendBenchmark(id) {
        return this.rest.one('campaign', id).one('getSendBenchmark').get();
    };
    
    removeExport() {
        return this.rest.all('campaign/removeExport').post();
    };
    
    sendPreview(campaignId, to, emailId) {
        return this.rest.all('campaign/preview').post({
            campaign_id: campaignId,
            preview_to: to,
            email_id: emailId
        });
    }

    getRecipientCount(id) {
        return this.rest.one('campaign', id).one('recipientCount').get();
    };

    pollRecipientCount(id) {
        return this.rest.one('campaign', id).one('pollRecipientCount').get();
    };

    sendEvent(id) {
        return this.rest.one('campaign', id).one('sendEvent').get()
    };

    pause(id) {
        return this.rest.all('campaign/pause').post({ id: id });
    };

    restart(id) {
        return this.rest.all('campaign/restart').post({ id: id} );
    };

    copy(id, withoutAbTestId, email_template_id) {
        let payload = { id };
        payload.withoutAbTestId = (withoutAbTestId != null) ? withoutAbTestId : false;
        if (email_template_id) {
            payload.email_template_id = email_template_id;
        }
        return this.rest.all('campaign/copy').post(payload);
    };

    setSchedule(schedule) {
        return this.rest.all('campaign/schedule').post(schedule);
    };

    getSchedule(id) {
        return this.rest.one('campaign', id).one('schedule').get();
    };

    destroy(id) {
        return this.rest.one('campaign', id).remove();
    };

    getHistoryMeta(id) {
        return this.rest.one('campaign', id).one('history').get();
    };

    update(id, campaign) {
        return this.rest.one('campaign', id).customPUT(campaign);
    };

    create(campaign) {
        return this.rest.all('campaign').post({ campaign: campaign });
    };

    getLatestTextMessageContent(id) {
        return this.rest.one('campaign', id).one('textMessageContent').get();
    };

    setTrackingCampaignCode(id, emailId, code) {
        return this.rest.all('campaign/' + id + '/email/' + emailId + '/trackingCode').post({ code: code });
    };

    setTrackingTermCode(id, emailId, code) {
        return this.rest.all('campaign/' + id + '/email/' + emailId + '/trackingTermCode').post({ code: code });
    };

    setLanguage(id, language) {
        return this.rest.all('campaign/' + id + '/language').post({ language: language });
    };
    
    getPlainContent(campaignId) {
        return this.rest.one('campaign', campaignId).one('emailContent').get({ type: 'text/plain' });
    };
};
